"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNotificationContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var rcNotificationFadeIn = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);
var rcNotificationFadeOut = (0, _ykbStyledComponents.keyframes)(["0%{opacity:1;}100%{opacity:0;}"]);
var NotificationStyles = (0, _ykbStyledComponents.createGlobalStyle)([".", ".topLeft{left:0px;top:0px;}.", ".topRight{right:0px;top:0px;}.", ".topCenter{top:100px;left:50%;transform:translateX(-50%);}.", ".bottomLeft{left:0px;bottom:0px;}.", ".bottomRight{right:0px;bottom:0px;}.", "{position:fixed;z-index:", ";width:", ";margin:", ";font-size:", ";&-fade-enter{opacity:0;animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);animation-play-state:paused;}&-fade-leave{animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);animation-play-state:paused;}&-notice.", "-fade-enter.", "-fade-enter-active{animation-name:", ";animation-play-state:running;}&-notice.", "-fade-leave.", "-fade-leave-active{animation-name:", ";animation-play-state:running;}.notification-success{color:", ";background:", ";border:1px solid ", ";.notification-notice-icon{color:", ";}.notification-notice-message{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;color:", " !important;}&.bordered{.notification-notice-icon{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;}}}.notification-warning{color:", ";background:", ";border:1px solid ", ";.notification-notice-icon{color:", ";}.notification-notice-message{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;color:", " !important;}&.bordered{.notification-notice-icon{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;}}}.notification-error{color:", ";background:", ";border:1px solid ", ";.notification-notice-icon{color:", ";}.notification-notice-message{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;color:", " !important;}&.bordered{.notification-notice-icon{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;}}}.notification-info{color:", ";background:", ";border:1px solid ", ";.notification-notice-icon{color:", ";}.notification-notice-message{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;color:", " !important;}&.bordered{.notification-notice-icon{color:", ";}.notification-notice-action{background-color:", " !important;border-color:", " !important;}}}.notification-success,.notification-warning,.notification-error,.notification-info{&:not(.bordered){.notification-notice-header{color:", ";}}}&-notice{padding:10px;border-radius:", ";background:", ";display:block;width:auto;line-height:1.5;position:relative;margin:", " 0px;&-content{position:relative;.notification-notice-header{font-size:", ";color:", ";margin-bottom:4px;display:inline-block;font-weight:500;line-height:19px;}.notification-notice-message{font-size:", ";color:", ";white-space:pre-line;}.notification-notice-with-icon{display:flex;}.notification-notice-header-message-wrapper{padding-left:10px;width:100%;.notification-notice-header,.notification-notice-message{padding-right:30px;}> *:not(:first-child){margin-top:10px;}.notification-notice-action{float:right !important;margin-right:0px !important;}}.notification-notice-icon{line-height:1 !important;font-size:", "px;}}&-close{position:absolute;right:10px;top:10px;color:#000;cursor:pointer;outline:none;font-size:", "px;line-height:1;filter:alpha(opacity=30);opacity:0.3;text-decoration:none;&:hover{opacity:0.5;filter:alpha(opacity=50);color:#000;text-decoration:none;}}&.with-title{.notification-notice-icon{top:15px;margin:0;}}&.bordered{background:", ";.notification-notice-action{color:", " !important;}.notification-notice-header{color:", ";}.notification-notice-message{color:", ";}}&.with-action{padding:15px;&:not(.with-title){.", "-notice-content{margin-top:30px;}}.", "-notice-close{right:15px;top:15px;}}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.notification.zIndex;
}, function (props) {
  return props.theme.notification.width;
}, function (props) {
  return props.theme.notification.margin;
}, function (props) {
  return props.theme.notification.fontSize;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcNotificationFadeIn, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcNotificationFadeOut, function (props) {
  return props.theme.notification.success.textColor;
}, function (props) {
  return props.theme.notification.success.backgroundColor;
}, function (props) {
  return props.theme.notification.success.backgroundColor;
}, function (props) {
  return props.theme.notification.success.iconColor;
}, function (props) {
  return props.theme.notification.success.textColor;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.notification.success.backgroundColor;
}, function (props) {
  return props.theme.notification.success.backgroundColor;
}, function (props) {
  return props.theme.notification.success.backgroundColor;
}, function (props) {
  return props.theme.notification.success.backgroundColor;
}, function (props) {
  return props.theme.notification.warning.textColor;
}, function (props) {
  return props.theme.notification.warning.backgroundColor;
}, function (props) {
  return props.theme.notification.warning.backgroundColor;
}, function (props) {
  return props.theme.notification.warning.iconColor;
}, function (props) {
  return props.theme.notification.warning.textColor;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.notification.warning.backgroundColor;
}, function (props) {
  return props.theme.notification.warning.backgroundColor;
}, function (props) {
  return props.theme.notification.warning.backgroundColor;
}, function (props) {
  return props.theme.notification.warning.backgroundColor;
}, function (props) {
  return props.theme.notification.error.textColor;
}, function (props) {
  return props.theme.notification.error.backgroundColor;
}, function (props) {
  return props.theme.notification.error.backgroundColor;
}, function (props) {
  return props.theme.notification.error.iconColor;
}, function (props) {
  return props.theme.notification.error.textColor;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.notification.error.backgroundColor;
}, function (props) {
  return props.theme.notification.error.backgroundColor;
}, function (props) {
  return props.theme.notification.error.backgroundColor;
}, function (props) {
  return props.theme.notification.error.backgroundColor;
}, function (props) {
  return props.theme.notification.info.textColor;
}, function (props) {
  return props.theme.notification.info.backgroundColor;
}, function (props) {
  return props.theme.notification.info.backgroundColor;
}, function (props) {
  return props.theme.notification.info.iconColor;
}, function (props) {
  return props.theme.notification.info.textColor;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.notification.info.backgroundColor;
}, function (props) {
  return props.theme.notification.info.backgroundColor;
}, function (props) {
  return props.theme.notification.info.backgroundColor;
}, function (props) {
  return props.theme.notification.info.backgroundColor;
}, function (props) {
  return props.theme.notification.info.textColor;
}, function (props) {
  return props.theme.notification.borderRadius;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.notification.padding;
}, function (props) {
  return props.theme.notification.fontSize;
}, function (props) {
  return props.theme.notification.color;
}, function (props) {
  return props.theme.notification.fontSize;
}, function (props) {
  return props.theme.notification.color;
}, function (props) {
  return props.theme.notification.iconSize;
}, function (props) {
  return props.theme.notification.iconSize;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.notification.color;
}, function (props) {
  return props.theme.notification.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
});
var Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className;
  // last classname what we need
  var prefix = className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(NotificationStyles, {
    theme: theme,
    prefixCls: prefix
  }), children(prefix));
};
var StyledNotificationContainer = exports.StyledNotificationContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-1vrrn2q-0"
})([""]);